export default "/banner.jpg"